import Categories from './Categories'

export default function ProductCategories() {
  return <Categories categoryType="product" />
}
